/* import __COLOCATED_TEMPLATE__ from './replied-to-conversations-comparison-counter.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import ViewConfig, { GROUPINGS } from 'embercom/lib/reporting/flexible/view-config';
import { FILTER_PROPERTY_PLACEHOLDER } from 'embercom/components/reporting/flexible/chart';
import { units } from 'embercom/lib/reporting/flexible/formatters';
import {
  CARDINALITY,
  COMMENT_CREATED_AT,
  CONVERSATION_ID,
  TEAMMATE_REPLIES_FILTERS,
} from 'embercom/lib/reporting/flexible/constants';
import { improvementDirections } from 'embercom/components/reporting/element/summary-comparison';
import { inject as service } from '@ember/service';

const seriesName = 'conversations_replied_to_counter';

export default class RepliedToConversationsComparisonCounter extends Component {
  @service intl;

  get modifiedFilters() {
    let newFilters = { ...this.args.filters };

    if (newFilters.admin_participant_ids) {
      newFilters.teammate_id = newFilters.admin_participant_ids;
      delete newFilters.admin_participant_ids;
    }

    return newFilters;
  }

  get viewConfig() {
    let viewConfig = new ViewConfig();

    viewConfig.formatUnit = { unit: units.value };
    viewConfig.aggregations = { defaultOption: CARDINALITY };
    viewConfig.groupings = {
      defaultOption: {
        ...GROUPINGS[COMMENT_CREATED_AT],
        isComparison: true,
        createTitleTooltipText: () =>
          this.intl.t('reporting.conversations-report.conversations-replied-to.tooltip'),
      },
    };
    viewConfig.counter = {
      [seriesName]: {
        improvementDirection: improvementDirections.INCREASING,
      },
    };

    return viewConfig;
  }

  get dataConfig() {
    return {
      series: [
        {
          name: seriesName,
          source: 'consolidated_conversation_part',
          type: CARDINALITY,
          data: { property: CONVERSATION_ID },
          time: {
            property: COMMENT_CREATED_AT,
            start: FILTER_PROPERTY_PLACEHOLDER,
            end: FILTER_PROPERTY_PLACEHOLDER,
          },
          filter: {
            type: 'and',
            filters: TEAMMATE_REPLIES_FILTERS,
          },
        },
      ],
    };
  }
}
